import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { LifeStageModeEnum } from "@/Patient/Models/LifeStageModeEnum";

class BaseMedicalItemsViewState {
    constructor(s?: Partial<BaseMedicalItemsViewState>) {
        if (s != null) {
            this.AvailableMedicalProblemStatus = s.AvailableMedicalProblemStatus;
            this.SelectedMedicalProblemStatusLookupId = s.SelectedMedicalProblemStatusLookupId;
            this.LifeStageMode = s.LifeStageMode ?? LifeStageModeEnum.Date;
            this.LifeStageStartDate = s.LifeStageStartDate;
            this.LifeStageIsStartDateApproximative = s.LifeStageIsStartDateApproximative ?? false;
            this.LifeStageAgeAtOnset = s.LifeStageAgeAtOnset;
            this.LifeStageAgeSelectedgeAtOnsetUnit = s.LifeStageAgeSelectedgeAtOnsetUnit;
            this.LifeStageAvailableAgeAtOnsetUnits = s.LifeStageAvailableAgeAtOnsetUnits ?? cacheStore.FindLookupsByTypeCode("DayYear");
            this.LifeStageAvailableLifestages = s.LifeStageAvailableLifestages ?? cacheStore.FindLookupsByTypeCode("LIFESTAGE");
            this.LifeStageSelectedLifestageLookupId = s.LifeStageSelectedLifestageLookupId;
            this.LifeStageDatePrecision = s.LifeStageDatePrecision ?? LifeStageDatePrecisionEnum.Day;
            this.LifeStageDateTextboxValue = s.LifeStageDateTextboxValue;
        }
    }

    public SelectedMedicalProblemStatusLookupId: string;
    public AvailableMedicalProblemStatus: FlatLookupView[];

    public LifeStageMode: LifeStageModeEnum;

    // LifestageType = start date
    public LifeStageStartDate: Date;
    public LifeStageIsStartDateApproximative: boolean;

    // LifestageType = onset age
    public LifeStageAgeAtOnset: number;
    public LifeStageAgeSelectedgeAtOnsetUnit: string;
    public LifeStageAvailableAgeAtOnsetUnits: FlatLookupView[];

    public LifeStageDatePrecision: LifeStageDatePrecisionEnum;
    public LifeStageDateTextboxValue: string;

    // LifestateType = lifestage
    public LifeStageAvailableLifestages: FlatLookupView[];
    public LifeStageSelectedLifestageLookupId: string;
}

export { BaseMedicalItemsViewState };
